module.exports = __webpack_public_path__ + "img/azimuthal-grid.e7acc3dc.png";